const logos: Record<string, string> = {
    gusto: '/img/institutions/gusto.svg',
    ins_56: '/img/institutions/chase.svg',
};

export default logos;
